import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Navbar from './layout/components/Navbar';
import './bootstrap.css';
import './Style.scss';
import Home from './layout/pages/Home';
import CompountWireCutter from './layout/Projects/CompountWireCutter';
import Plier from './layout/Projects/Plier';
import ToolKitNav from './layout/components/ToolKitNav';
import SoilAuger from './layout/Projects/SoilAuger';
import About from './layout/pages/About';
function App() {
  return (
    <div className="App">
     
      <Router>
        <Navbar/>
        <div className="container">
        <Switch>
          <Route exact path='/'>
            <Home />
            <ToolKitNav/>
          </Route>
          <Route exact path='/compoundwirecutter'>
            <CompountWireCutter />
          </Route>
          <Route exact path='/plier'>
            <Plier />
          </Route>
          <Route exact path='/soilauger'>
            <SoilAuger />
          </Route>
          <Route exact path='/about'>
            <About />
          </Route>
        </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
